module.exports = __webpack_public_path__ + "img/img0.9c5101de.jpg";